export const WARNING_VAREJO = (
  <>
    <strong>O indicador considera todos os produtos concorrentes selecionados e todas as redes concorrentes selecionadas.</strong> Caso queira monitorar um
    único produto concorrente ou em uma rede específica, selecione apenas o produto concorrente ou rede desejada.
  </>
);

export const WARNING_PRODUTO = (
  <>
    <strong>
      O índice de competitividade exibido no alerta é a competitividade média geral entre o produto de referência e os produtos concorrentes, nas redes
      selecionadas.
    </strong>{' '}
    Caso queira receber um alerta específico para um único produto concorrente ou em uma rede específica, selecione apenas um produto concorrente ou rede e
    crie um novo alerta.
  </>
);
